import { LightMode } from "@/components/ui/color-mode";
import {
  CashRequestStatus,
  CheckRequestStatus,
  CounterDeliveryStatus,
  ScheduledTransferStatus,
  SellOrderStatus,
  TransferRequestStatus,
} from "@/constants/entity-status";
import { AppColors } from "@/styles/colors";
import { Badge, Text } from "@chakra-ui/react";
import { useMemo } from "react";

interface Props {
  status?:
    | CashRequestStatus
    | CheckRequestStatus
    | TransferRequestStatus
    | ScheduledTransferStatus
    | SellOrderStatus
    | CounterDeliveryStatus;
  noPaddingY?: boolean;
}

export const RequestStatusBadge = ({ status, noPaddingY }: Props) => {

  console.log(status)
  const { bgColor, label } = useMemo(() => {
    switch (status) {
      case CashRequestStatus.AVAILABLE:
      case CheckRequestStatus.AVAILABLE:
        return { bgColor: AppColors.LIGHT_GREEN, label: status };
      case CashRequestStatus.TO_PROCESS:
      case CheckRequestStatus.TO_PROCESS:
      case TransferRequestStatus.PENDING:
      case SellOrderStatus.TO_PROCESS:
        return { bgColor: AppColors.YELLOW_SECONDARY, label: status };
      case CashRequestStatus.NEEDS_INFO:
      case CheckRequestStatus.NEEDS_INFO:
        return {
          bgColor: AppColors.BLACK_TEXT_SECONDARY,
          label: "Requiere info.",
        };
      case CounterDeliveryStatus.IN_NEGOTIATION:
        return { bgColor: AppColors.BLACK_TEXT_SECONDARY,
          label: "En negociación",};

      case CashRequestStatus.REJECTED:
      case CheckRequestStatus.REJECTED:
      case TransferRequestStatus.REJECTED:
      case TransferRequestStatus.FAILED:
      case ScheduledTransferStatus.REJECTED:
      case ScheduledTransferStatus.FAILED:
      case SellOrderStatus.REJECTED:
        return { bgColor: AppColors.RED_ICON, label: status };
      case CashRequestStatus.FINISHED:
      case CheckRequestStatus.FINISHED:
      case TransferRequestStatus.FINISHED:
      case ScheduledTransferStatus.FINISHED:
      case SellOrderStatus.FINISHED:
        return { bgColor: AppColors.GREEN_PRIMARY, label: status };
      case ScheduledTransferStatus.SCHEDULED:
        return { bgColor: AppColors.YELLOW_ALT, label: status };
      case ScheduledTransferStatus.ON_REVISION:
        return { bgColor: AppColors.RED_ICON_ALT, label: "En revisión" };
      default:
        return { bgColor: "transparent", label: status };
    }
  }, [status]);

  if (!status) return null;

  return (
    <LightMode>
      <Badge bgColor={bgColor}>
        <Text
          paddingY={noPaddingY ? "" : "4px"}
          paddingX="8px"
          fontSize="12px"
          color={AppColors.WHITE_SECONDARY}
          data-testid="request-status-badge-text"
        >
          {label}
        </Text>
      </Badge>
    </LightMode>
  );
};
